"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasEvents = exports.AbstractCanvas = void 0;
var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _CanvasObject = require("./Objects/CanvasObject");
var _Observable = require("./Observable");
var _Image = require("../Utils/Image");
var _UnitConversion = require("../Utils/UnitConversion");
var _Device = require("../Utils/Device");
var _Logger = _interopRequireDefault(require("../Utils/Logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger["default"]('AbstractCanvas');
var CanvasEvents = exports.CanvasEvents = /*#__PURE__*/function (CanvasEvents) {
  CanvasEvents["OnChange"] = "onChange";
  CanvasEvents["OnObjectChange"] = "onObjectChange";
  CanvasEvents["OnSizeChange"] = "onSizeChange";
  return CanvasEvents;
}({});
var AbstractCanvas = exports.AbstractCanvas = /*#__PURE__*/function () {
  function AbstractCanvas(canvasElement) {
    var _this2 = this;
    _classCallCheck(this, AbstractCanvas);
    _defineProperty(this, "objects", []);
    _defineProperty(this, "zoom", 1);
    _defineProperty(this, "canvasElement", void 0);
    _defineProperty(this, "selectedObject", null);
    _defineProperty(this, "size", {
      width: 0,
      height: 0,
      dpi: 0
    });
    _defineProperty(this, "_objectEventsEnabled", true);
    _defineProperty(this, "_observable", new _Observable.Observable(this));
    _defineProperty(this, "triggerObjectChangeEvent", function (target, eventData) {
      _this2._objectEventsEnabled && _this2._observable.triggerEvent(CanvasEvents.OnObjectChange, {
        changeEvent: {
          target: target,
          eventData: eventData
        }
      });
    });
    if (canvasElement) {
      var width = canvasElement.width,
        height = canvasElement.height;
      this.init(canvasElement, {
        canvasSize: {
          width: width,
          height: height
        }
      });
    }
  }
  _createClass(AbstractCanvas, [{
    key: "init",
    value: function init(canvasElement, options) {
      if (canvasElement instanceof HTMLCanvasElement) {
        this.canvasElement = canvasElement;
      } else if ((0, _isPlainObject["default"])(canvasElement)) {
        this.canvasElement = this.createCanvasElement(canvasElement);
      }
      if (_typeof(options) === 'object') {
        var canvasSize = options.canvasSize;
        if (canvasSize) {
          this.setSize(canvasSize);
        }
      }
      // there can be a previously called fromObject function, so we can call it here after initializations
      // note: the fromObject implementation in the canvas adapter may work only after the canvas is available
      // (like in Paper.js, the added objects are visible only when the canvas is already available)
      this._fromObject && this._fromObject();
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      // remove canvas reference
      this.canvasElement = null;
    }
  }, {
    key: "createCanvasElement",
    value: function createCanvasElement() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          width: 0,
          height: 0
        },
        width = _ref.width,
        height = _ref.height;
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      return canvas;
    }
  }, {
    key: "add",
    value: function add(obj) {
      this.objects.push(obj);
      obj.canvas = this;
      obj.on(_CanvasObject.CanvasObjectEvents.OnChange, this.triggerObjectChangeEvent);
      return this;
    }
  }, {
    key: "remove",
    value: function remove(obj) {
      var idx = this.objects.indexOf(obj);
      if (idx !== -1) {
        if (this.selectedObject === obj) {
          this.deselectObject(obj);
        }
        this.objects.splice(idx, 1);
        obj.off(_CanvasObject.CanvasObjectEvents.OnChange, this.triggerObjectChangeEvent);
        this.triggerObjectChangeEvent(obj);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      // restore the canvas state
      this.clearSelection();
      // remove all objects
      while (this.objects.length > 0) {
        this.objects.pop().remove();
      }
    }
  }, {
    key: "indexOfObject",
    value: function indexOfObject(obj) {
      return this.objects.indexOf(obj);
    }
  }, {
    key: "setObjectIndex",
    value: function setObjectIndex(obj, newIdx) {
      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var idx = this.objects.indexOf(obj);
      if (idx !== -1) {
        // remove the object from its current position
        this.objects.splice(idx, 1);
        if (overwrite) {
          // overwrite mode
          this.objects[newIdx] = obj;
        } else {
          // insert mode
          var newIdxFixed = Math.max(Math.min(newIdx, this.objects.length), 0);
          this.objects.splice(newIdxFixed, 0, obj);
        }
      }
    }
  }, {
    key: "getSize",
    value: function getSize() {
      return this.size;
    }
  }, {
    key: "getSizeMetric",
    value: function getSizeMetric() {
      var dpi = this.size.dpi || (0, _Device.getScreenDPI)();
      return {
        width: (0, _UnitConversion.pixelsToMms)(this.size.width, dpi),
        height: (0, _UnitConversion.pixelsToMms)(this.size.height, dpi)
      };
    }
  }, {
    key: "setZoom",
    value: function setZoom(zoom) {
      this.zoom = zoom;
      return this;
    }
  }, {
    key: "getZoom",
    value: function getZoom() {
      return this.zoom;
    }
  }, {
    key: "setSize",
    value: function setSize() {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSize();
      if (size.isMetric) {
        return this.setSizeMetric(size);
      }
      if (!(0, _isEqual["default"])(this.size, size)) {
        this.size = size;
        this._observable.triggerEvent(CanvasEvents.OnSizeChange);
      }
      return this;
    }
  }, {
    key: "setSizeMetric",
    value: function setSizeMetric(metricSize) {
      var width = metricSize.width,
        height = metricSize.height,
        dpi = metricSize.dpi;
      var size = {
        width: (0, _UnitConversion.mmsToPixels)(width, dpi),
        height: (0, _UnitConversion.mmsToPixels)(height, dpi),
        dpi: dpi
      };
      if (!(0, _isEqual["default"])(this.size, size)) {
        this.size = size;
        this._observable.triggerEvent(CanvasEvents.OnSizeChange);
      }
      return this;
    }
  }, {
    key: "updateObjectConstraints",
    value: function updateObjectConstraints() {
      var _iterator = _createForOfIteratorHelper(this.objects),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var o = _step.value;
          o.updateConstraints();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "update",
    value: function update() {
      return this;
    }
  }, {
    key: "getWrapperObject",
    value: function getWrapperObject(wrappedObj) {
      var _iterator2 = _createForOfIteratorHelper(this.objects),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var o = _step2.value;
          if (o.wrappedObject === wrappedObj) {
            return o;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return false;
    }
  }, {
    key: "setSelectedObject",
    value: function setSelectedObject(object) {
      this.selectedObject = object;
      this._observable.triggerEvent(CanvasEvents.OnChange);
    }
  }, {
    key: "deselectObject",
    value: function deselectObject(object) {
      this.selectedObject = null;
      this._observable.triggerEvent(CanvasEvents.OnChange);
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (this.selectedObject) {
        this.selectedObject.selected = false;
        this.selectedObject = null;
        this.update(); // update immediately after clearing selection
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      var selectedObject = this.selectedObject,
        size = this.size;
      return {
        selectedObject: selectedObject ? selectedObject.getState() : null,
        size: size
      };
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      this._observable.on(eventName, callback);
    }
  }, {
    key: "off",
    value: function off(eventName, callback) {
      this._observable.off(eventName, callback);
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.objects.length;
    }
  }, {
    key: "toObject",
    value: function toObject() {
      var stringify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        includeObjects = _ref2.includeObjects,
        includeWrappedObject = _ref2.includeWrappedObject;
      var canvasObj = {};
      if (includeObjects) {
        var objects = [];
        var _iterator3 = _createForOfIteratorHelper(this.objects),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var o = _step3.value;
            objects.push(o.toObject(includeWrappedObject));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
        canvasObj.objects = objects;
      }
      return stringify ? JSON.stringify(canvasObj) : canvasObj;
    }
  }, {
    key: "toObjectWithMetric",
    value: function toObjectWithMetric() {
      var stringify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        includeWrappedObject = _ref3.includeWrappedObject;
      // include all objects with metric position and size
      var objects = [];
      var _iterator4 = _createForOfIteratorHelper(this.objects),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var o = _step4.value;
          var _obj = o.toObject(includeWrappedObject);
          var _o$getScaledSize = o.getScaledSize(),
            width = _o$getScaledSize.width,
            height = _o$getScaledSize.height;
          _obj.metric = {
            x: (0, _UnitConversion.pixelsToMms)(_obj.x),
            y: (0, _UnitConversion.pixelsToMms)(_obj.y),
            width: (0, _UnitConversion.pixelsToMms)(width),
            height: (0, _UnitConversion.pixelsToMms)(height)
          };
          objects.push(_obj);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var size = this.getSize();
      var canvasObj = _objectSpread(_objectSpread({}, this.toObject(stringify, {
        includeObjects: false
      })), {}, {
        objects: objects,
        size: size
      });
      return stringify ? JSON.stringify(canvasObj) : canvasObj;
    }
  }, {
    key: "updateFromObject",
    value: function () {
      var _updateFromObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(canvasObject) {
        var _this3 = this;
        var objects, wait, _loop, i;
        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this._objectEventsEnabled = false;
              objects = canvasObject.objects;
              wait = [];
              if (!(objects && objects.length > 0)) {
                _context2.next = 11;
                break;
              }
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var rawObject, currentObject;
                return _regeneratorRuntime().wrap(function _loop$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      rawObject = objects[i];
                      currentObject = _this3.objects.find(function (_ref4) {
                        var uuid = _ref4.uuid;
                        return uuid === rawObject.uuid;
                      });
                      if (currentObject) {
                        wait.push(currentObject.updateOptions(rawObject));
                      } else {
                        logger.error('Object not found!', rawObject);
                      }
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 6:
              if (!(i < objects.length)) {
                _context2.next = 11;
                break;
              }
              return _context2.delegateYield(_loop(), "t0", 8);
            case 8:
              i++;
              _context2.next = 6;
              break;
            case 11:
              _context2.next = 13;
              return Promise.all(wait);
            case 13:
              this._objectEventsEnabled = true;
              this._observable.triggerEvent(CanvasEvents.OnChange);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function updateFromObject(_x) {
        return _updateFromObject.apply(this, arguments);
      }
      return updateFromObject;
    }()
  }, {
    key: "fromObject",
    value: function () {
      var _fromObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(canvasObject) {
        var _this, objects, wait, i, addedObjects;
        return _regeneratorRuntime().wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.canvasElement) {
                _context4.next = 3;
                break;
              }
              _this = this;
              return _context4.abrupt("return", new Promise(function (resolve) {
                _this._fromObject = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                  var result;
                  return _regeneratorRuntime().wrap(function _callee2$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        delete _this._fromObject;
                        _context3.next = 3;
                        return _this.fromObject(canvasObject);
                      case 3:
                        result = _context3.sent;
                        resolve(result);
                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee2);
                }));
              }));
            case 3:
              this._objectEventsEnabled = false;
              this.clear();
              if (canvasObject) {
                _context4.next = 7;
                break;
              }
              return _context4.abrupt("return", Promise.resolve());
            case 7:
              objects = canvasObject.objects;
              wait = [];
              if (objects && objects.length > 0) {
                for (i = 0; i < objects.length; i++) {
                  wait.push(this.addItemFromObject(objects[i], i, true));
                }
              }
              _context4.next = 12;
              return Promise.all(wait);
            case 12:
              addedObjects = _context4.sent;
              this._objectEventsEnabled = true;
              return _context4.abrupt("return", addedObjects);
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this);
      }));
      function fromObject(_x2) {
        return _fromObject.apply(this, arguments);
      }
      return fromObject;
    }()
  }, {
    key: "drawRasterizedImage",
    value: function drawRasterizedImage(ctx, dx, dy, dWidth, dHeight) {
      this.update();
      (0, _Image.copyImageResampled)(this.canvasElement, ctx, dx, dy, dWidth, dHeight);
    }
  }, {
    key: "addToContainer",
    value:
    /**
     * Appends the canvas to the target container or to the body if the target is not specified
     * @param {HTMLElement} [containerElement]
     */
    function addToContainer() {
      var _this4 = this;
      var containerElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      var canvasElement = this.canvasElement;
      if (containerElement === document.body && canvasElement.parentNode) {
        // the canvas is already added to the DOM
        return false;
      }
      containerElement.appendChild(canvasElement);
      this.removeFromContainer = function () {
        containerElement.removeChild(canvasElement);
        _this4.removeFromContainer = function () {
          //do nothing
        };
      };
      return true;
    }

    /**
     * A placeholder function that is assigned in addToContainer above
     */
  }, {
    key: "removeFromContainer",
    value: function removeFromContainer() {
      //do nothing
    }
  }]);
  return AbstractCanvas;
}();